import axios from 'axios'

export const FrontEndMapService = {
  // get state list
  fetchNameFromAbbreviationList (formData) {
    return axios.post(`/public/api/v1/getEntityDetails`, JSON.stringify({
      code: formData.code,
      isAbbreviation: formData.isAbbreviation,
      codeLevel: formData.codeLevel,
      parentCode: formData.parentCode,
      parentLevel: formData.parentLevel
    })
    )
  }
}
